import { createGraphNodeEntityId } from '../ids/entityIds.js';
import { cloneGraphNode } from './nodeDefs.js';
import type { GraphEdge, GraphNode } from './nodeDefs.js';

export function createGraphNodeId(): string {
  return createGraphNodeEntityId();
}

export function cloneGraphWithFreshNodeIds(
  nodes: GraphNode[],
  edges: GraphEdge[],
): { nodes: GraphNode[]; edges: GraphEdge[] } {
  const idMap: Record<string, string> = {};
  const clonedNodes = nodes.map(node => {
    const id = createGraphNodeId();
    idMap[node.id] = id;
    return { ...cloneGraphNode(node), id };
  });
  const clonedEdges = edges.map(edge => ({
    fromNode: idMap[edge.fromNode] ?? edge.fromNode,
    fromPort: edge.fromPort,
    toNode: idMap[edge.toNode] ?? edge.toNode,
    toPort: edge.toPort,
  }));
  return { nodes: clonedNodes, edges: clonedEdges };
}
